<template>
    <div class="pay-result">
        <!-- <div class="invoiceSuccess flex-column align-center">
            <img class="invoiceSuccess-img" src="@/assets/images/pay/paySuccess.png" alt="" />

            <template>
                <div class="loading"></div>
                <p class="invoiceSuccess-text">支付成功</p>
            </template>
            <p class="invoiceSuccess-service-phone">服务热线：{{ zzconfig.PHONE }}</p>
        </div> -->

        <div class="success-top">
            <img src="@/assets/images/pay/paySuccess.png" alt="" />
            <div class="text-success">支付成功</div>
            <div class="text-alert">请于付款后15分钟内离场，以免产生额外费用</div>
        </div>
        <div class="success-middle"></div>

        <div class="success-bottom">
            <p class="invoiceSuccess-service-phone">服务热线：{{ zzconfig.PHONE }}</p>
        </div>
        <turntable :show.sync="showTurntable" :data='turnData' />
    </div>
</template>

<script>
import { zzconfig } from "@/config/zzconfig";
import Telephonne from "@/components/telephone";
import turntable from "@/components/base/turntable.vue";
import { getPopupActivit } from '@/api/apiNoAuth.js'
export default {
    name: "payResult",
    components: {
        Telephonne,
        turntable
    },
    data() {
        return {
            zzconfig,
            success: false, //开票是否成功
            showTurntable: false,
            turnData: {}
        };
    },
    mounted() {
        let that = this;
        getPopupActivit({ chennel: 1 }).then(res => {
            if (new Date(res.data.startTime.replace(' ', 'T')).getTime() < new Date().getTime() && new Date(res.data.endTime.replace(' ', 'T')).getTime() > new Date().getTime()) {
                this.showTurntable = true;
                this.turnData = res.data;

            }
        })
        // setTimeout(() => {
        //     this.$router.go(-2);
        // }, 2000);
    },
    methods: {
        // //客服热线
        service() {
            window.location.href = `tel:${zzconfig.PHONE}`;
        },
    },
};
</script>

<style lang="less" scoped>
.pay-result {
    background-color: #fff;
    width: 100vw;
    height: 100%;

    .success-top {
        width: 750px;
        height: 576px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
            height: 128px;
            width: 128px;
        }
        .text-success {
            margin-top: 50px;
            font-size: 32px;
        }
        .text-alert {
            margin-top: 31px;

            font-size: 28px;
            color: #999;
        }
    }

    .success-middle {
        width: 750px;
        height: 375px;
        background: url("~@/assets/images/pay/pay-ad.png") no-repeat;
        background-size: 100% 100%;
    }

    .invoiceSuccess-service-phone {
        font-size: 30px;
        text-align: center;
        color: #33333380;
        margin-top: 100px;
    }
}
</style>
